import {CompletedTimelineEvent} from '@ots-frontend/ots-data';
import {Text, ThemeIcon} from '@mantine/core'
import {useTranslation} from "react-i18next";
import {IconCircleCheckFilled} from "@tabler/icons-react";

type Props = {
    event: CompletedTimelineEvent;
};

export const CompletedTimelineItemTitle = (props: {}) => {
    const {t} = useTranslation(["common"])
    return <>{t("common.entity.dispatch.timeline.completed.title", "Completed")}</>
}

export const CompletedTimelineItemBullet = (props: {}) => {
    return (
        <ThemeIcon
            size={22}
            color="dispatch-completed"
            radius="xl"
        >
            <IconCircleCheckFilled size={12}/>
        </ThemeIcon>
    )
}

export const CompletedTimelineItem = (props: Props) => {
    const {t} = useTranslation(["common"])

    return (
        <>
            <Text color="dimmed" size="sm">
                {t("common.entity.dispatch.timeline.completed.summary", "Job completed.")}
            </Text>
        </>
    );
};

CompletedTimelineItem.Title = CompletedTimelineItemTitle
CompletedTimelineItem.Bullet = CompletedTimelineItemBullet;
